import { Box, Spinner } from "@chakra-ui/react";
import { POSTS_FRONT_EDITOR_RENDERER_TOOL_LIST } from "@raiden/library/constants/editeur";
import { LOCALES_LANG_NAMES } from "@raiden/library/constants/locales";
import { FilesEditorImageBlockChakra } from "@raiden/library/containers/Files/EditorImage/BlockChakra";
import { BLOCK_FILES_IMAGE } from "@raiden/library/containers/Files/EditorImage/BlockData";
import { useApi } from "@raiden/library/hooks/useApi";
import useLocale from "@raiden/library/hooks/useLocale";
import generateApiUri from "@raiden/library/libraries/utils/generateApiUri";
import {
  ContentRenderer,
  RendererChakra,
} from "@splitfire-agency/raiden-le-editeur/dist/renderers";
import SWRHandler from "../../../components/SWR/SWRHandler";

const TOOLS = [
  ...POSTS_FRONT_EDITOR_RENDERER_TOOL_LIST,
  {
    name: "Image",
    block: BLOCK_FILES_IMAGE,
    component: FilesEditorImageBlockChakra,
  },
];

/**
 * @typedef {Object} Props
 * @property {number | string} [idOrAlias] used to fetch the post to render
 * @property {import("@raiden/library/types/Post").Post} [post] used to render the post if already fetched
 *
 * @param {Props} props
 */
function PostsView({ idOrAlias, post }) {
  const strIdOrAlias =
    idOrAlias !== undefined ? idOrAlias.toString() : undefined;

  /** @type {import("@raiden/library/hooks/useApi").UseApi<import("@raiden/library/types/Post").Post>} */
  const { swrResponse } = useApi(
    post === undefined && (strIdOrAlias?.length ?? 0) > 0
      ? generateApiUri({
          id: "@posts.show",
          parameters: {
            postId: idOrAlias,
          },
          query: {
            fields: ["post.current_revision"],
          },
        })
      : null,
  );

  const { locale, defaultLocale } = useLocale();

  const language = {
    name: LOCALES_LANG_NAMES[locale ?? defaultLocale].name,
    key: locale ?? defaultLocale,
  };

  return (
    <>
      {post ? (
        <ContentRenderer
          tools={TOOLS}
          language={language}
          renderer={RendererChakra}
          document={post.current_revision?.content}
        />
      ) : (
        <SWRHandler
          swrResponse={swrResponse}
          loading={
            <Box px="1rem">
              <Spinner />
            </Box>
          }>
          {({ data: post }) => (
            <ContentRenderer
              tools={TOOLS}
              language={language}
              renderer={RendererChakra}
              document={post.current_revision?.content}
            />
          )}
        </SWRHandler>
      )}
    </>
  );
}

export default PostsView;
